export default {
  authenticatedUser: null,
  token: null,
  error: null,
  session: null,
  permissions: [],
};
